import ConfigFile from "../../../datasets/config_file";

export const checkIfHistoryUpdate = (currentGameDate, gameID, investType, historyTranArr, 
        historyExists) =>{

    const historyYearCutoff = ConfigFile.investments.historyYears;
    const gameDateArr = currentGameDate.split('-');
    const historyYear = +gameDateArr[0] - +historyYearCutoff;
    let moveToHistory = false;
    let newHistoryArr = [];
    let gameInvestHistoryObj = {};
    const historyStartDate = historyYear + '-01';
    const maxIndx = historyTranArr.length - 1;
    for (let i=maxIndx; i>=0; i--){
        const historyTran = historyTranArr[i];
        if (historyTran.dateClosed < historyStartDate){
            moveToHistory = true;
            newHistoryArr.push(historyTran);
            historyTranArr.splice(i,1);
        }
    }
    if (moveToHistory === true){
        historyExists = true;
        newHistoryArr.sort((a, b) => (+a.transNbr > b.transNbr) ? 1 : -1)
        gameInvestHistoryObj = {gameID: gameID, investType: investType, 
            historyTranArr: newHistoryArr
        }
    }
    return gameInvestHistoryObj;
}
export default checkIfHistoryUpdate;